import { render } from "./Profile.vue?vue&type=template&id=28861309&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-28861309"

export default script